import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordInjuryIllness, EmploymentRecordInjuryIllnessSubmit } from '../models/employment-record-injury-illness.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordInjuryIllnessService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getInjuryIllnesss(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/InjuryIllness`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            injuryIllnesss: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getInjuryIllness(employeeId: string, employmentRecordId: string, injuryIllnessId: string): Observable<EmploymentRecordInjuryIllness> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/InjuryIllness/${injuryIllnessId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postInjuryIllness(employeeId: string, employmentRecordId: string, injuryIllness: EmploymentRecordInjuryIllnessSubmit): Observable<EmploymentRecordInjuryIllness> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/InjuryIllness`, injuryIllness, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deleteInjuryIllness(employeeId: string, employmentRecordId: string, injuryIllnessId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/InjuryIllness/${injuryIllnessId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

